import script from "./KnowledgeDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeDetail.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeDetail.vue?vue&type=style&index=0&id=638a7c06&lang=less"
import "./KnowledgeDetail.vue?vue&type=style&index=1&id=638a7c06&lang=less&scoped=true"
import "./KnowledgeDetail.vue?vue&type=style&index=2&id=638a7c06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-638a7c06"]])

export default __exports__